import {FormControl, FormField, RadioOption} from 'platform/components';
import {Heading, Show, VStack} from 'platform/foundation';

import {UseFormReturn, useWatch} from 'react-hook-form';

import {useGetWarehousesQuery} from '@dms/api/warehouse';
import i18n from '@dms/i18n';
import {getOptionsFromWarehouses} from '@dms/shared';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {OverviewForm} from '../types/OverviewForm';

interface WarehouseScopeProps extends RequiredTestIdProps {
  control: FormControl<OverviewForm>;
  formApi: UseFormReturn<OverviewForm>;
}

export function WarehouseScope(props: WarehouseScopeProps) {
  const warehouseScope = useWatch({control: props.control, name: 'articlesScope.warehouseScope'});

  const warehousesQuery = useGetWarehousesQuery();

  const handleWarehouseScopeChange = (value: string | null) => {
    if (value === SELECT) {
      props.formApi.setValue('articlesScope.warehouseScope.articleScopeWarehouseAll', false);
      return;
    }

    props.formApi.setValue('articlesScope.warehouseScope.articleScopeWarehouseAll', true);
    props.formApi.setValue('articlesScope.warehouseScope.articleScopeWarehouses', null);
  };

  return (
    <VStack spacing={4}>
      <Heading size={5}>{i18n.t('entity.warehouse.labels.warehouse')}</Heading>
      <FormField
        control={props.control}
        type="radio"
        name="articlesScope.warehouseScope.option"
        options={options}
        onChange={handleWarehouseScopeChange}
        direction="column"
        spacing={4}
        data-testid={suffixTestId('inputs.warehouseScope', props)}
      />
      <Show when={warehouseScope.option === SELECT}>
        <FormField
          isLoading={warehousesQuery.isLoading}
          control={props.control}
          type="multiChoice"
          name="articlesScope.warehouseScope.articleScopeWarehouses"
          options={getOptionsFromWarehouses(warehousesQuery.data)}
          data-testid={suffixTestId('inputs.selectedWarehouse', props)}
        />
      </Show>
    </VStack>
  );
}

const ALL = 'all';
const SELECT = 'select';

const options: RadioOption[] = [
  {
    label: i18n.t('entity.warehouse.labels.enableForAllWarehouses'),
    value: ALL,
  },
  {
    label: i18n.t('entity.warehouse.labels.selectWarehouse'),
    value: SELECT,
  },
];
